import React from 'react';

import './common/global.css';

import Home from './pages/Home';

const App = () => {
  return (
    <Home />
  );
}

export default App;
